<template>
  <div>
    <b-jumbotron :lead="'Bonjour ' + user.name"/>
    <div>
      <b-card-group deck>
        <b-card
          header="Création des comptes clients"
          header-tag="header">
          <b-card-group
            deck
            class="home-card">
            <router-link
              :to="{ name: 'ContractAdd' }"
              :class="isAuthorized(['admin', 'seller', 'trainer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconNewContract.data().viewBox"
                  width="50"
                  height="50"
                  icon-name="new-contract"><icon-new-contract /></icon-base>
              </b-card-text>
              <b-card-text>
                Ajouter un contrat
              </b-card-text>
            </router-link>
            <router-link
              :to="{ name: 'TagHandler' }"
              :class="isAuthorized(['admin', 'seller', 'trainer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconNewContract.data().viewBox"
                  width="50"
                  height="50"
                  icon-name="new-contract"><icon-new-contract /></icon-base>
              </b-card-text>
              <b-card-text>
                Gestion des tags
              </b-card-text>
            </router-link>
          </b-card-group>
        </b-card>
        <b-card
          header="Suivi clients"
          header-tag="header"
        >
          <b-card-group
            deck
            class="home-card">
            <router-link
              :to="{ name: 'Contracts' }"
              :class="isAuthorized(['admin', 'seller', 'trainer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconContractList.data().viewBox"
                  width="50"
                  height="50"
                  icon-name="contract-list"><icon-contract-list /></icon-base>
              </b-card-text>
              <b-card-text>
                Contrats
              </b-card-text>
            </router-link>
            <router-link
              :to="{ name: 'Establishments' }"
              :class="isAuthorized(['admin', 'seller', 'trainer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconEstablishment.data().viewBox"
                  width="50"
                  height="50"
                  icon-name="establishment"><icon-establishment /></icon-base>
              </b-card-text>
              <b-card-text>
                Etablissements
              </b-card-text>
            </router-link>
            <router-link
              :to="{ name: 'StatsEstablishments' }"
              :class="isAuthorized(['admin', 'seller', 'trainer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconMonitoring.data().viewBox"
                  width="50"
                  height="50"
                  icon-name="monitoring"><icon-monitoring /></icon-base>
              </b-card-text>
              <b-card-text>
                Suivi client
              </b-card-text>
            </router-link>
            <router-link
              :to="{ name: 'Troubleshooting' }"
              :class="isAuthorized(['admin', 'seller', 'trainer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconHelp.data().viewBox"
                  width="50"
                  height="50"
                  icon-name="help"><icon-help /></icon-base>
              </b-card-text>
              <b-card-text>
                Dépannage
              </b-card-text>
            </router-link>
          </b-card-group>
        </b-card>
      </b-card-group>
    </div>
    <div class="mt-4">
      <b-card-group deck>
        <b-card
          header="Formation"
          header-tag="header"
        >
          <b-card-group
            deck
            class="home-card">
            <router-link
              :to="{ name: 'TrainingDocs' }"
              :class="isAuthorized(['admin', 'trainer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconTraining.data().viewBox"
                  width="50"
                  height="50"
                  icon-name="training"><icon-training /></icon-base>
              </b-card-text>
              <b-card-text>
                Documents de formation
              </b-card-text>
            </router-link>
          </b-card-group>
        </b-card>
        <b-card
          header="Outils de développement"
          header-tag="header">
          <b-card-group
            deck
            class="home-card">
            <router-link
              :to="{ name: 'MiniQuiz' }"
              :class="isAuthorized(['admin', 'trainer', 'product']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconUpgrade.data().viewBox"
                  width="50"
                  height="50"
                  icon-name="upgrade"><icon-upgrade /></icon-base>
              </b-card-text>
              <b-card-text>
                Gestion de la Quizothèque
              </b-card-text>
            </router-link>
            <router-link
              :to="{ name: 'Musique' }"
              :class="isAuthorized(['admin', 'developer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconMusic.data().viewBox"

                  width="50"
                  height="50"
                  icon-name="music"><icon-music /></icon-base>
              </b-card-text>
              <b-card-text>
                Gestion de la Musique
              </b-card-text>
            </router-link>            
            <router-link
              :to="{ name: 'Connector' }"
              :class="isAuthorized(['admin', 'developer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconConnector.data().viewBox"

                  width="50"
                  height="50"
                  icon-name="connector"><icon-connector /></icon-base>
              </b-card-text>
              <b-card-text>
                Connecteur NETSOINS
              </b-card-text>
            </router-link>
            <router-link
              :to="{ name: 'ConnectorTiti' }"
              :class="isAuthorized(['admin', 'developer']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconConnector.data().viewBox"

                  width="50"
                  height="50"
                  icon-name="connector"><icon-connector /></icon-base>
              </b-card-text>
              <b-card-text>
                Connecteur TITAN
              </b-card-text>
            </router-link>
          </b-card-group>
        </b-card>
      </b-card-group>
    </div>
    <div class="mt-4">
      <b-card-group deck>
        <b-card
          header="Statistiques"
          header-tag="header">
          <b-card-group
            deck
            class="home-card">
            <router-link
              :to="{ name: 'Export' }"
              :class="isAuthorized(['admin', 'trainer', 'seller']) ? 'classicLink' : 'disabledLink'"
              tag="b-card">
              <b-card-text class="card-icon">
                <icon-base
                  :view-box="IconXlsExport.data().viewBox"

                  width="50"
                  height="50"
                  icon-name="xls-export"><icon-xls-export /></icon-base>
              </b-card-text>
              <b-card-text>
                Exports Excel
              </b-card-text>
            </router-link>
          </b-card-group>
        </b-card>
      </b-card-group>
    </div>
  </div>
</template>
<script>
import IconBase from '../components/icons/IconBase.vue';
import IconEstablishment from '../components/icons/IconEstablishment.vue';
import IconAccounting from '../components/icons/IconAccounting.vue';
import IconContractList from '../components/icons/IconContractList.vue';
import IconNewContract from '../components/icons/IconNewContract.vue';
import IconNewEstablishment from '../components/icons/IconNewEstablishment.vue';
import IconMonitoring from '../components/icons/IconMonitoring.vue';
import IconUpgrade from '../components/icons/IconUpgrade.vue';
import IconAgenda from '../components/icons/IconAgenda.vue';
import IconTraining from '../components/icons/IconTraining.vue';
import IconTesting from '../components/icons/IconTesting.vue';
import IconXlsExport from '../components/icons/IconXlsExport.vue';
import IconHelp from '../components/icons/IconHelp.vue';
import IconConnector from '../components/icons/IconConnector.vue';
import IconMusic from '../components/icons/IconMusic.vue'
import { getUser} from '../storage.js'
export default {
  components: {
    IconBase,
    IconEstablishment,
    IconAccounting,
    IconContractList,
    IconNewContract,
    IconNewEstablishment,
    IconMonitoring,
    IconUpgrade,
    IconAgenda,
    IconTraining,
    IconTesting,
    IconXlsExport,
    IconHelp,
    IconConnector,
    IconMusic
  },
  data() {
    return {
      IconEstablishment,
      IconAccounting,
      IconContractList,
      IconNewContract,
      IconNewEstablishment,
      IconMonitoring,
      IconAgenda,
      IconUpgrade,
      IconTraining,
      IconTesting,
      IconXlsExport,
      IconHelp,
      IconConnector,
      IconMusic
    };
  },
  computed: {
    user() {
      return getUser();
    }
  },
  methods: {
    isAuthorized(authorized) {
      return authorized.includes(this.user.access_type);
    },
  },
};
</script>

<style>
  .home-card {
    padding: 15px;
  }
  .home-card .card {
    cursor: pointer;
    box-shadow: #83cee6 1px 1px 3px 1px;
    background: #83cee6;
  }
  .home-card .disabledLink {
    cursor: not-allowed;
    box-shadow: #b5d6e0 1px 1px 3px 1px;
    background: #b5d6e0;
  }
  .home-card .card .card-text {
    color: white;
    font-weight: 600;
    padding: 0.5rem;
    font-size: 0.9rem;
    line-height: 1.1;
  }
  .home-card .card-text:last-child {
    min-height: 5vh;
  }
  .card-header {
    color: black;
  }
  .home-card .card-icon {
    color: white;
    font-weight: normal;
  }
  .home-card .card-body {
    padding: 0.5rem;
  }
</style>
